import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [ "checkbox" ];

  initialize() {
    this.defaultLimit = 4;
  }

  check(event) {
    if (this.checkboxTargets.filter((c) => c.checked).length > (this.data.get("limit") || this.defaultLimit)) {
      event.target.checked = false;
    }
  }
}
